import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { Localizer } from "../../common/extendibles/Localizer.js";

import "@polymer/paper-listbox/paper-listbox.js";
import "@polymer/paper-item/paper-item.js";
import "@polymer/paper-button/paper-button.js";
import "@polymer/paper-icon-button/paper-icon-button.js";
import "@polymer/iron-icon/iron-icon.js";

import "../../common/widgets/lag-spinner.js";

import { defineElement } from "../../utility/defineElement.js";
import { styles } from "../../styles/common-styles.css.js";
import { template } from "./lag-duallistbox-selector.html.js";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";

defineElement(class extends Localizer(PolymerElement) {
    static get is() { return "lag-duallistbox-selector"; }
    static get template() { return html`${styles}${template}`; }
    static get properties() {
        return {
            _items: {
                type: Array,
                value: []
            },
            _selectedItems: {
                type: Array,
                value: []
            },
            _valueField: {
                type: String,
                value: ""
            },
            _displayFormat: {
                type: String,
                value: ""
            },
            unselectedLabel: {
                type:String,
                value: "Items"
            },
            selectedLabel: {
                type:String,
                value: "Selected"
            }
        };
    }

    ready() {
        super.ready();
    }

    // == Public Methods ==
    init({ items, valueField, displayFormat, unselectedLabel, selectedLabel }) {
        this.reset()
        this._items = items;
        this._selectedItems = [];
        this._valueField = valueField;
        this._displayFormat = displayFormat;
        this._unselectedLabel = unselectedLabel;
        this._selectedLabel = selectedLabel;
    }

    reset() {
        this._items = [];
        this._valueField = "";
        this._displayFormat = "";
        this._unselectedLabel = "Items";
        this._selectedLabel = "Selected";
    }

    getSelectedItems() { return this._selectedItems; }

    // == Private Methods ==
    _getFormattedDisplay(item) {
        let output = this._displayFormat;

        Object.keys(item).forEach(key => {
            output = output.replace(`{${key}}`, item[key]);
        });

        return output;
    }

    // == UI Action Handlers ==

    _handleAddSelected() {
        const item = this._items[this.$.plbItems.selected];

        // if items empty we do nothing and return
        if (!item)
            return;

        // add item to email List
        this.push("_selectedItems", item);

        // remove item from previous list since it being added to other side.
        this.splice("_items", this.$.plbItems.selected, 1);

        //select new email in list
        afterNextRender(this.$.plbSelectedItems, _ => {
            this.$.plbSelectedItems.selected = this._selectedItems.length - 1;
        });

        //select moved email in contact list
        afterNextRender(this.$.plbItems, _ => {
            if (this.$.plbItems.selected > this._items.length - 1)
                this.$.plbItems.selected = this._items.length - 1;
        });
    }

    _handleRemoveSelected() {
        if (!this._selectedItems || !this._selectedItems.length)
            return;

        const item = this._selectedItems[this.$.plbSelectedItems.selected];

        // if items empty we do nothing and return
        if (!item)
            return;

        // add back to contact list
        this.push("_items", item);


        // remove item from previous list since it being added to other side.
        this.splice("_selectedItems", this.$.plbSelectedItems.selected, 1);

        //select last email in tolist
        afterNextRender(this.$.plbSelectedItems, _ => {
            this.$.plbSelectedItems.selected = this._selectedItems.length - 1;
        });

        //select moved email in contact list
        afterNextRender(this.$.plbItems, _ => {
            this.$.plbItems.selected = this._items.length - 1;
        });
    }
});
